import { render, staticRenderFns } from "./addGroupBuy.vue?vue&type=template&id=3afbc3cc&scoped=true&"
import script from "./addGroupBuy.vue?vue&type=script&lang=js&"
export * from "./addGroupBuy.vue?vue&type=script&lang=js&"
import style0 from "./addGroupBuy.vue?vue&type=style&index=0&id=3afbc3cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afbc3cc",
  null
  
)

export default component.exports